<template>
	<app-page>
		<app-heading title="Notifications" />
		<app-row>
			<app-cell>
				<app-data-table
					:items="groups"
					:headers="headers"
					:total="count"
					@update="fetchGroups"
				>
					<template v-slot:actions="{ item }">
						<app-button
							color="secondary"
							:to="{ name: 'subscribers', params: { group: item.code } }"
							table
						>
							Manage
						</app-button>
					</template>
				</app-data-table>
			</app-cell>
		</app-row>
	</app-page>
</template>

<script>
export default {
	data() {
		return {
			groups: [],
			count: -1,
			headers: [{
				text: 'Group',
				value: 'name',
				sortable: false,
			}, {
				text: 'Actions',
				value: 'actions',
				align: 'end',
				sortable: false,
			}],
		}
	},
	methods: {
		async fetchGroups(pagination) {
			const request = this.$ravello.request()
				.to('notifications')
				.to('groups')
				.fromPagination(pagination)

			try {
				this.groups = await request.get()
				if (this.count === -1) {
					const count = await request.count()
					this.count = count.count
				}
			} catch (err) {
				this.$notifications.pushAlert('error', err.data.message)
			}
		},
	},
}
</script>
